export default __webpack_public_path__ + "static/logicloud-min-630c5fdb9f899e52a55d2dcd6897c630.png";